import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ImageModelChooser} from './image-model-item/image-model-item.component';
import {ImageService} from '../../../_services/api/image.service';

@Component({
  selector: 'app-image-model-chooser',
  templateUrl: './image-model-chooser.component.html',
  styleUrls: ['./image-model-chooser.component.scss']
})
export class ImageModelChooserComponent implements OnInit {
  @Input() imageModel: string;
  @Input() selectedImageModelName: string;
  @Output() changeImageModelName: EventEmitter<string> = new EventEmitter();
  imageSelector: ImageModelChooser[];
  constructor(public imageService: ImageService) { }

  ngOnInit(): void {
    this.imageService.getModelSettings(this.imageModel).subscribe( res => {
      this.imageSelector = res.data;
      this.imageSelector.forEach(i => {
        i.isSelected = i.name === this.selectedImageModelName;
      });
    });
  }

  selectedModel(item: ImageModelChooser) {
    this.imageSelector.forEach(i => {
      i.isSelected = i.name === item.name;
      this.changeImageModelName.emit(item.name);
    });
  }

}
